import { Alert } from '@mui/material';
import { useKeycloak } from '@react-keycloak/web';
import { Fragment, useCallback, useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import { translate } from 'react-switch-lang';
import { Button, Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import { DeleteButtonIcon } from 'src/component/Buttons/DeleteButtonIcon';
import { InfoButtonIcon } from 'src/component/Buttons/InfoButtonIcon';
import SweetAlert from 'sweetalert2';
import { useHttpClient } from '../../../../../security/hooks/axiosProvider';
import Breadcrumb from '../../../breadcrumb';
import styles from '../../../styles/style-setting.module.scss';
import CreateUnit from '../create-unit/create-unit';
import DetailUnit from '../detail-unit/detail-unit';
import EditUnit from '../edit-unit/edit-unit';
import UnitColumns from './table-header/unit-columns';

const NUMBER_OF_UNIT_PER_PAGE = 15;
const ListUnit = (props) => {
  const httpClient = useHttpClient(true);
  const [units, setUnits] = useState([]);
  const [unit, setUnit] = useState({});
  const [pageNumber, setPageNumber] = useState(0);
  const activityPerPage = NUMBER_OF_UNIT_PER_PAGE;
  const pagesVisited = pageNumber * NUMBER_OF_UNIT_PER_PAGE;
  // const pageCount = Math.ceil(units.length / activityPerPage);
  const changePage = ({ selected }) => setPageNumber(selected);
  const keycloak = useKeycloak().keycloak;
  const [role, setRole] = useState('');
  const [search, setSearch] = useState('');
  let data = [];
  const [spinner, setSpinner] = useState({ state: false, id: '' });
  const [modelDetail, setModelDetail] = useState(false);
  const pageCount = Math.ceil(
    (search === '' ? units : units.filter((unit) => unit.name.includes(search) || unit.value.includes(search))).length /
      activityPerPage
  );
  const modelDetailToggle = (unitValue) => {
    setModelDetail(!modelDetail);
    setUnit(unitValue);
  };

  const getUnits = useCallback(async () => {
    httpClient.current?.get(`/api/unit/all`).then((response) => {
      setUnits(response.data);
    });
  }, [httpClient]);

  const deleteUnit = async (unitId) => {
    await httpClient.current?.delete(`/api/unit/${unitId}`);
    getUnits();
  };

  const handleCheckBox = async (event, unit) => {
    setSpinner({ state: true, id: unit.id });
    const unitValidation = {
      id: unit.id,
      name: unit.name,
      value: unit.value,
      description: unit.description,
      valid: event.target.checked,
    };
    const response = httpClient.current?.put(`/api/unit/update`, unitValidation);
    if ((await response).status === 200) {
      getUnits();
      setSpinner({ state: false, id: unit.id });
    }
  };

  useEffect(() => {
    getUnits();
    if (keycloak.authenticated) {
      keycloak.hasResourceRole('ROLE_AGRISED_ADMIN_SUPER')
        ? setRole('super admin')
        : keycloak.hasResourceRole('ROLE_AGRISED_ADMIN')
        ? setRole('admin')
        : setRole('user');
    }
  }, [getUnits, keycloak]);

  let restPagination = units
    .filter(
      (unit) =>
        unit.name.toUpperCase().includes(search.toUpperCase()) ||
        unit.value.toUpperCase().includes(search.toUpperCase())
    )
    .slice(pagesVisited, pagesVisited + activityPerPage);

  restPagination.map((unit) => {
    let action = (
      <div>
        <InfoButtonIcon
          onClick={() => modelDetailToggle(unit)}
          title={props.t('more_details')}
          className={`fa fa-eye  ${styles['action']}`}
        />
        <span>
          <EditUnit unit={unit} units={getUnits} />
        </span>
        <span>
          <DeleteButtonIcon
            title={props.t('delete_unit')}
            onClick={() =>
              SweetAlert.fire({
                title: props.t('you_delete'),
                text: props.t('not_recover'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ok',
                cancelButtonText: props.t('cancel'),
                reverseButtons: true,
              }).then((result) => {
                if (result.value) {
                  deleteUnit(unit.id);

                  SweetAlert.fire(props.t('Deleted!'), props.t('isDeleted'), 'success');
                } else {
                  SweetAlert.fire(props.t('isNotDeleted'));
                }
              })
            }
            className={`fa fa-trash  ${styles['trash']}`}
          />
        </span>
      </div>
    );
    let status =
      spinner.state === true && spinner.id === unit.id ? (
        <div className={`loader-box  ${styles['spinner']}`}>
          <div className="loader-2"></div>
        </div>
      ) : (
        <input
          type="checkbox"
          disabled={role === 'admin'}
          name="status"
          checked={unit?.valid}
          onChange={(e) => handleCheckBox(e, unit)}
        />
      );
    data.push({
      name: unit.name,
      value: unit.value,
      description: unit.description,
      status: status,
      action: action,
    });
    return data;
  });

  return (
    <>
      <div>
        <Fragment>
          <Breadcrumb parent={props.t('unit_url')} url={'settings/unit'} />
          <Container fluid={true}>
            <Row>
              <Col sm="12">
                <Card>
                  <CardHeader>
                    <div className="float-right">
                      <CreateUnit units={getUnits} />
                    </div>
                  </CardHeader>
                  <CardBody>
                    <input
                      className="form-control col-md-6 mb-2 "
                      onChange={(event) => {
                        setSearch(event.target.value);
                        changePage({ selected: 0 });
                      }}
                      value={search}
                      placeholder={props.t('search_unit')}
                    />
                    {data.length === 0 ? (
                      <Alert variant="outlined" severity="info">
                        {props.t('no_units')}
                      </Alert>
                    ) : (
                      <UnitColumns data={data} />
                    )}
                    <br />
                    <div className="float-right">
                      {units.length > NUMBER_OF_UNIT_PER_PAGE && (
                        <ReactPaginate
                          previousLabel="<"
                          nextLabel=">"
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={styles['paginationButton']}
                          previousLinkClassName={styles['previousBtn']}
                          nextLinkClassName={styles['nextBtn']}
                          disabledClassName={styles['paginationDisabled']}
                          activeClassName={styles['paginationActive']}
                        />
                      )}
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </Fragment>
      </div>
      <Modal isOpen={modelDetail} toggle={modelDetailToggle} centered>
        <ModalHeader>{props.t('detail_unit')}</ModalHeader>
        <ModalBody>
          <DetailUnit unit={unit} />
          <div>
            <Button color="secondary" className="float-right" onClick={modelDetailToggle}>
              {props.t('Cancel')}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(ListUnit);
